import { render, staticRenderFns } from "./BDXWizardTPANames.vue?vue&type=template&id=76eb2f89"
import script from "./BDXWizardTPANames.vue?vue&type=script&lang=js"
export * from "./BDXWizardTPANames.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports